import { IRecipt } from '../types/Recipt';

export const receiptAdapter = (item?: IRecipt) => ({
  success: item?.success ?? false,
  qr: {
    receipt_no: item?.qr?.receipt_no ?? 0,
    sign: item?.qr?.sign ?? '',
    term_id: item?.qr?.term_id ?? '',
    url: item?.qr?.url ?? '',
  },
  image: item?.image ?? '',
  message: item?.message
    ? {
        uz: item.message.uz,
        ru: item.message.ru,
      }
    : undefined,
});
